import React from 'react'

export default function about() {
    let myStyle={
        minHeight: "81vh"
    }
    return (
        <div className="container text-center p-5" style={myStyle}>
            <h3>About this app</h3>
            <p >This is a Todo list app. You can add todos to this app. This app uses browser local storage to store the data. This app is made with React, it uses react router.</p>
        </div>
    )
}
